export default __webpack_public_path__ + "f949912c23bcdd877ed6d2c17ec34557.png";